var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceShower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.584,
    height: 56.019,
    viewBox: "0 0 36.584 56.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38719",
    "data-name": "\\uADF8\\uB8F9 38719",
    transform: "translate(1.697 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_58",
    "data-name": "\\uD328\\uC2A4 58",
    d: "M2148.249,1147.052a10.54,10.54,0,0,0-10.54,10.54h21.08A10.54,10.54,0,0,0,2148.249,1147.052Z",
    transform: "translate(-2136.578 -1135.93)",
    fill: "#f09",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_59",
    "data-name": "\\uD328\\uC2A4 59",
    d: "M2148.249,1147.052a10.54,10.54,0,0,0-10.54,10.54h21.08A10.54,10.54,0,0,0,2148.249,1147.052Z",
    transform: "translate(-2136.578 -1135.93)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_48",
    "data-name": "\\uC120 48",
    y2: 2.001,
    transform: "translate(11.671 26.228)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_49",
    "data-name": "\\uC120 49",
    y2: 2.001,
    transform: "translate(11.671 33.093)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_50",
    "data-name": "\\uC120 50",
    x2: 1.415,
    y2: 1.415,
    transform: "translate(17.073 26.228)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_51",
    "data-name": "\\uC120 51",
    x2: 1.415,
    y2: 1.415,
    transform: "translate(21.927 31.082)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_52",
    "data-name": "\\uC120 52",
    x1: 1.415,
    y2: 1.415,
    transform: "translate(4.854 26.228)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_53",
    "data-name": "\\uC120 53",
    x1: 1.415,
    y2: 1.415,
    transform: "translate(0 31.082)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_60",
    "data-name": "\\uD328\\uC2A4 60",
    d: "M2176.458,1116.612v-5.447s-.826-5.105,5.4-5.105h12.055s4.56-.126,4.56,5.276v48.341",
    transform: "translate(-2164.787 -1106.06)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceShower);
export default __webpack_public_path__ + "static/media/icon-service-shower.5e5e537d74e31cb991ccab7a1c3ee252.svg";
export { ForwardRef as ReactComponent };